module.exports = __webpack_public_path__ + "static/media/icon-wb_sunny.bd2d7b84.svg";